import { useCMSPage } from '@web-app/hooks/use-cms-page';

import { ERouting } from '@core/type';

import { makeServerProps } from '../../../../../helpers/make-server-props/make-server-props';
import { ViewProductPageProps, ViewProductShow } from '../../../../../view';

const PageProductShow = (props: ViewProductPageProps) =>
  useCMSPage({
    ViewPage: ViewProductShow,
    ...props,
  });

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.PRODUCT_SHOW,
  hasSanity: true,
});

export { getServerSideProps };

export default PageProductShow;
